<template>
  <input-masked
    v-if="mask"
    v-model="modelValue"
    v-bind="$props"
    :mask
    required
    :transforms
    type="text"
  />
  <vf-input
    v-else
    v-model="modelValue"
    v-bind="vfInputProps"
    data-test-id="input-postal-code"
    :inputmode
    :label="label || $t.zipCode"
    type="text"
    @change="$emit('change', $event)"
  >
    <slot />
    <template v-if="$slots.before" #before>
      <slot name="before" />
    </template>
    <template v-if="$slots.after" #after>
      <slot name="after" />
    </template>
  </vf-input>
</template>

<script lang="ts" setup>
import type { Emits, Props, Slots } from '#brands/components/vf/input/Input.vue'

const { mask, transforms, ...vfInputProps } = defineProps<Omit<Props, 'min' | 'max' | 'type' | 'inputmode'> & {
  label?: string
  mask?: string
  transforms?: string[]
}>()

defineEmits<Emits>()

defineSlots<Slots>()

const modelValue = defineModel<string>({ default: '' })
const countryCode = useCountryCode()
const inputmode = ['CA', 'GB', 'IE', 'NL'].includes(countryCode) ? 'text' : 'numeric'
</script>
